function processProductBadges() {
    $(".product").each(function () {
        const $flagsDefault = $(this).find(".flags-default");
        if (!$flagsDefault.length) return;

        const $badgeFlags = $flagsDefault.find(".flag").filter(function () {
            const style = $(this).attr("style") || "";
            return style.includes("background-color: #123456") || style.includes("background-color: rgb(18, 52, 86)");
        });

        if (!$badgeFlags.length) return;

        const $badges = $("<div class='flags flags-badges'></div>");

        $badgeFlags.each(function () {
            const $flag = $(this);
            const cleanedStyle = ($flag.attr("style") || "").replace(/order\s*:\s*-?\d+\s*;?/gi, "").trim();
            if (cleanedStyle) {
                $flag.attr("style", cleanedStyle);
            } else {
                $flag.removeAttr("style");
            }
            $badges.append($flag);
        });

        $badges.insertAfter($flagsDefault);
    });
}

function processDetailBadges() {
    const $target = $(".p-detail-inner-header");
    if (!$target.length) return;

    const $flagsDefault = $(".p-detail-info .flags-default");
    if (!$flagsDefault.length) return;

    const $badgeFlags = $flagsDefault.find(".flag").filter(function () {
        const style = $(this).attr("style") || "";
        return style.includes("background-color: #123456") || style.includes("background-color: rgb(18, 52, 86)");
    });

    if (!$badgeFlags.length) return;

    const $badges = $("<div class='flags flags-badges'></div>");

    $badgeFlags.each(function () {
        const $flag = $(this);
        const cleanedStyle = ($flag.attr("style") || "").replace(/order\s*:\s*-?\d+\s*;?/gi, "").trim();
        if (cleanedStyle) {
            $flag.attr("style", cleanedStyle);
        } else {
            $flag.removeAttr("style");
        }
        $badges.append($flag);
    });

    $badges.appendTo($target);
}

$(document).ready(function () {
    processProductBadges();
    processDetailBadges();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    processProductBadges();
    processDetailBadges();
});
